import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ArrowRight, Target } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4 max-w-4xl mx-auto text-center bg-gradient-to-b from-[#0a0a0a] to-[#111] border-y border-white/5 relative overflow-hidden pt-[15px] pb-[15px]" data-id="element-216">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(220,38,38,0.03)_0%,transparent_70%)] pointer-events-none" data-id="element-217" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative z-10" data-id="element-218">
        <div className="flex justify-center mb-6" data-id="element-219">
          <div className="p-3 rounded-2xl bg-red-500/10 border border-red-500/20" data-id="element-220">
            <AlertCircle className="w-6 h-6 text-red-500" data-id="element-221" />
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-black mb-6 leading-tight text-white tracking-tight" data-id="element-222">
          EL DESORDEN ES <br data-id="element-223" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-800" data-id="element-224">
            TU PEOR ENEMIGO
          </span>
        </h2>

        <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-xl mx-auto leading-relaxed font-[800]" data-id="element-225">
          Perdés tiempo, plata… y seguís en el mismo lugar.
        </p>

        <div className="max-w-md mx-auto" data-id="element-226">
          <motion.div whileHover={{
          scale: 1.02
        }} className="relative group" data-id="element-227">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-red-500/50 to-red-900/50 rounded-2xl blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200" data-id="element-228" />
            <div className="relative flex flex-col items-center bg-[#0a0a0a] border border-red-500/20 p-8 rounded-2xl shadow-2xl pt-[11px] pb-[11px] gap-[2px]" data-id="element-229">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-500/10 mb-2" data-id="element-230">
                <Target className="w-6 h-6 text-red-500" data-id="element-231" />
              </div>
              <div className="space-y-1" data-id="element-232">
                <p className="text-3xl md:text-4xl font-black text-white uppercase tracking-tighter" data-id="element-233">
                  ESTANCAMIENTO
                </p>
                <p className="text-sm font-bold text-red-500 uppercase tracking-[0.2em]" data-id="element-234">
                  Mucho contenido. Cero resultados.
                </p>
              </div>
              <div className="w-full h-px bg-gradient-to-r from-transparent via-red-500/20 to-transparent my-2" data-id="element-235" />
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}